// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicesDescription_sectionDescription__Sn3Sj {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-top: 40px;
}
.ServicesDescription_conteiner__dQLzW{
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 1110px;
    width: 100%;
    align-items: start;
}

.ServicesDescription_item__1Cdas {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.ServicesDescription_iconWrapper__7w-AQ {
    flex-shrink: 0;
    width: 62px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ServicesDescription_description__Hh10H {
    margin: 0;
    white-space: pre-line; /* Сохраняем переносы строк из исходного текста */
    font-size: var(--font-size-2xl);
    line-height: 1.5;
    text-align: left;
    display: inline;
} 

.ServicesDescription_warning__EZ475 {
    color: var(--color-primary);
    font-style: italic;
    font-weight: bold;
}

.ServicesDescription_warningInline__C02dh {
    display: inline;
    color: #FF6B6B; /* или любой другой оттенок красного */
    margin-left: 4px;
    font-style: italic;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
    .ServicesDescription_item__1Cdas{
        display: flex;
        flex-direction: column;
        flex-direction: column;
        align-items: center;
        padding: 10px 20px;
        gap: 15px;
        background-color: #fff;
        border-radius: var(--border-radius-lg);
    }
    .ServicesDescription_iconWrapper__7w-AQ svg{
        fill: var(--color-background);
    }
    .ServicesDescription_description__Hh10H{
        font-size: var(--font-size-md);
        color: var(--color-background);
    }
} `, "",{"version":3,"sources":["webpack://./src/components/EntToEndUI/ServicesDescription/ServicesDescription.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,qBAAqB,EAAE,iDAAiD;IACxE,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc,EAAE,sCAAsC;IACtD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,SAAS;QACT,sBAAsB;QACtB,sCAAsC;IAC1C;IACA;QACI,6BAA6B;IACjC;IACA;QACI,8BAA8B;QAC9B,8BAA8B;IAClC;AACJ","sourcesContent":[".sectionDescription {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    margin-top: 40px;\n}\n.conteiner{\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    max-width: 1110px;\n    width: 100%;\n    align-items: start;\n}\n\n.item {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.iconWrapper {\n    flex-shrink: 0;\n    width: 62px;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.description {\n    margin: 0;\n    white-space: pre-line; /* Сохраняем переносы строк из исходного текста */\n    font-size: var(--font-size-2xl);\n    line-height: 1.5;\n    text-align: left;\n    display: inline;\n} \n\n.warning {\n    color: var(--color-primary);\n    font-style: italic;\n    font-weight: bold;\n}\n\n.warningInline {\n    display: inline;\n    color: #FF6B6B; /* или любой другой оттенок красного */\n    margin-left: 4px;\n    font-style: italic;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n    .item{\n        display: flex;\n        flex-direction: column;\n        flex-direction: column;\n        align-items: center;\n        padding: 10px 20px;\n        gap: 15px;\n        background-color: #fff;\n        border-radius: var(--border-radius-lg);\n    }\n    .iconWrapper svg{\n        fill: var(--color-background);\n    }\n    .description{\n        font-size: var(--font-size-md);\n        color: var(--color-background);\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionDescription": `ServicesDescription_sectionDescription__Sn3Sj`,
	"conteiner": `ServicesDescription_conteiner__dQLzW`,
	"item": `ServicesDescription_item__1Cdas`,
	"iconWrapper": `ServicesDescription_iconWrapper__7w-AQ`,
	"description": `ServicesDescription_description__Hh10H`,
	"warning": `ServicesDescription_warning__EZ475`,
	"warningInline": `ServicesDescription_warningInline__C02dh`
};
export default ___CSS_LOADER_EXPORT___;
